import { TransactionResult } from "@bridgesplit/react";

export const STALE_ORACLE_SIMULATION_MESSAGE =
    "Unable to simulate due to Stale Oracle, oracle will be atomically updated when sending transaction.";

const STALE_ORACLE_SIMULATION_PATTERNS = [
    /stale[\s_-]*oracle/i,
    /oracle[\s_-]*stale/i,
    /stale[\s_-]*price/i,
    /price[\s_-]*stale/i
];

export function getStaleOracleSimulationMessage(messages: Array<string | undefined>): string | undefined {
    const hasStaleOracleMessage = messages
        .filter((message): message is string => !!message)
        .some((message) => STALE_ORACLE_SIMULATION_PATTERNS.some((pattern) => pattern.test(message)));

    return hasStaleOracleMessage ? STALE_ORACLE_SIMULATION_MESSAGE : undefined;
}

export function getStaleOracleSimulationMessageFromTransactionResult(
    result: Pick<TransactionResult, "error" | "simulationLogs">
): string | undefined {
    return getStaleOracleSimulationMessage([result.error, ...(result.simulationLogs ?? [])]);
}
